<template>
	<div>		<el-card class="box-card">
			<el-table :data="distributorList" border stripe :header-cell-style="{ textAlign: 'center' }"
				:cell-style="{ textAlign: 'center' }">
				<el-table-column type="index" width="60"></el-table-column>
				<el-table-column label="运营商名称" prop="name"></el-table-column>
				<el-table-column label="登录账号" prop="loginName"></el-table-column>
				<el-table-column label="负责人" prop="chargePerson"></el-table-column>
				<el-table-column label="电话" prop="telephone1"></el-table-column>
				<el-table-column label="地址" prop="address"></el-table-column>
				<el-table-column label="邮箱" prop="email"></el-table-column>
				<el-table-column label="注册时间" prop="registerTime" width="180"></el-table-column>
				<el-table-column fixed="right" header-align="center" align="center" width="180" label="操作">
					<template slot-scope="scope">
						<el-button size="mini" type="primary" icon="el-icon-edit"
							@click="updateDistributorInit(scope.row.id)">编辑</el-button>
						<el-button size="mini" type="primary" icon="el-icon-setting"
							@click="distributorSettingInit(scope.row.id)"></el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="distributorPageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100]"
				:page-size="distributorPageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>

			<el-dialog title="修改运营商信息" :visible.sync="updateDistributorDialogVisible" width="800px">
				<el-form :model="distributorInfo" status-icon :rules="addDistributorRules" ref="distributorInfoUpdate"
					label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="运营商名称:" prop="name">
							<el-input v-model.trim="distributorInfo.name" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="地址:" prop="address">
							<el-input v-model.trim="distributorInfo.address" type="text" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="登录账号:" prop="loginName">
							<el-input v-model.trim="distributorInfo.loginName" type="text" size="small"
								:disabled="true"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="负责人姓名:" prop="chargePerson">
							<el-input v-model.trim="distributorInfo.chargePerson" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="手机号:" prop="telephone1">
							<el-input v-model.trim="distributorInfo.telephone1" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="email:" prop="email">
							<el-input v-model.trim="distributorInfo.email" size="small" :clearable=true></el-input>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateDistributorDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="updateDistributor()">确 定
					</el-button>
				</span>
			</el-dialog>

			<el-dialog title="设置运营商配置" :visible.sync="distributorSettingInitDialogVisible" width="1200px">
				<el-table :data="deviceTypeConfigList" border stripe :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }" v-loading="configLoading">
					<el-table-column type="index" width="60"></el-table-column>
					<el-table-column label="车锁类型" width="100">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.bicycleType === 1" type="success" size="small">自行车锁</el-tag>
							<el-tag v-else-if="scope.row.bicycleType === 2" type="primary" size="small">电动车锁</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="车辆类型" prop="deviceTypeName"></el-table-column>
					<el-table-column label="第1阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage1Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第1阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage1Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="第2阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage2Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第2阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage2Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="第3阶段(分钟)" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage3Minute ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="第3阶段收费" width="100">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).stage3Fee ?? '-' }}元
						</template>
					</el-table-column>
					<el-table-column label="押金" width="80">
						<template slot-scope="scope">
							{{ getSettingConfig(scope.row.deviceTypeCode).precharge ?? '-' }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="120" fixed="right">
						<template slot-scope="scope">
							<el-button size="mini" style="background-color: #3CA757;color: #FFFFFF;" icon="el-icon-edit"
								@click="editDeviceTypeConfig(scope.row)">编辑</el-button>
						</template>
					</el-table-column>
				</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="distributorSettingInitDialogVisible = false">关 闭</el-button>
				</span>
			</el-dialog>

			<el-dialog :title="configDialogTitle" :visible.sync="configDialogVisible" width="900px" append-to-body>
				<el-form :model="configForm" :rules="configRules" ref="configFormRef" label-width="120px" style="padding-right: 50px;">
					<el-row>
						<el-col :span="24">
							<el-divider content-position="left">
								<el-tag v-if="configForm.bicycleType === 1" type="success" size="small">自行车锁</el-tag>
								<el-tag v-else-if="configForm.bicycleType === 2" type="primary" size="small">电动车锁</el-tag>
								- {{ configForm.deviceTypeName }}
							</el-divider>
						</el-col>
					</el-row>
					<el-divider content-position="left">第1阶段（起步价）</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage1Minute">
								<el-input v-model.trim="configForm.stage1Minute" size="small" :clearable=true placeholder="如：15"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage1Fee">
								<el-input v-model.trim="configForm.stage1Fee" size="small" :clearable=true placeholder="如：1.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">第2阶段</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage2Minute">
								<el-input v-model.trim="configForm.stage2Minute" size="small" :clearable=true placeholder="如：45"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage2Fee">
								<el-input v-model.trim="configForm.stage2Fee" size="small" :clearable=true placeholder="如：2.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">第3阶段（循环计费）<el-tooltip content="超过第2阶段后，每满足多少分钟收取对应费用" placement="top"><i class="el-icon-question"></i></el-tooltip></el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="分钟区间:" prop="stage3Minute">
								<el-input v-model.trim="configForm.stage3Minute" size="small" :clearable=true placeholder="如：30"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="区间收费:" prop="stage3Fee">
								<el-input v-model.trim="configForm.stage3Fee" size="small" :clearable=true placeholder="如：1.50"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-divider content-position="left">其他设置</el-divider>
					<el-row>
						<el-col :span="12">
							<el-form-item label="扫码说明">
								<el-switch v-model="configForm.sweepCodeStatus"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="扫码提示语:" prop="sweepCodeTip" v-if="configForm.sweepCodeStatus">
								<el-input v-model="configForm.sweepCodeTip" size="small" :clearable=true></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="押金">
								<el-switch v-model="configForm.prechargeStatus"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="押金额度:" prop="precharge" v-if="configForm.prechargeStatus">
								<el-input v-model="configForm.precharge" size="small" :clearable=true></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="调度费">
								<el-switch v-model="configForm.allowDispatch"></el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="调度费用:" prop="dispatchingFee" v-if="configForm.allowDispatch">
								<el-input v-model="configForm.dispatchingFee" size="small" :clearable=true placeholder="如：5.00"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="电子围栏还车">
								<el-switch v-model="configForm.enableFenceReturn"></el-switch>
								<el-tooltip content="开启后，用户关锁时将自动还车" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="超出区域报警">
								<el-switch v-model="configForm.enableOutAreaAlarm"></el-switch>
								<el-tooltip content="开启后，车辆超出运营区域时将通知管理员" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="蓝牙开锁">
								<el-switch v-model="configForm.enableBluetoothUnlock"></el-switch>
								<el-tooltip content="开启后，用户可使用蓝牙开锁；关闭则仅支持网络开锁" placement="top">
									<i class="el-icon-question" style="margin-left: 5px;"></i>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="运营时间:" prop="operationTime">
								<el-time-picker is-range v-model="configForm.operationTime" format="HH:mm" value-format="HH:mm" range-separator="-" start-placeholder="开始" end-placeholder="结束" size="small" style="width: 100%;"></el-time-picker>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="configDialogVisible = false">取 消</el-button>
					<el-button style="background-color: #3CA757;color: #FFFFFF;" @click="saveDeviceTypeConfig">确 定</el-button>
				</span>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			distributorPageInfoReq: {
				page: 1,
				limit: 8,
				mobile: '',
				queryDistributorId: ''
			},
			updateDistributorDialogVisible: false,
			distributorSettingInitDialogVisible: false,
			distributorList: [],
			distributorInfo: {},
			total: 0,
			addDistributorRules: {
				name: [{ required: true, message: '请输入运营商名称', trigger: ['blur', 'change'] }],
				loginName: [{ required: true, message: '请输入登录账号', trigger: ['blur', 'change'] }],
				chargePerson: [{ required: true, message: '请输入真实姓名', trigger: ['blur', 'change'] }],
				telephone1: [{ required: true, message: '请输入手机号', trigger: ['blur', 'change'] }]
			},
			currentDistributorId: '',
			deviceTypeConfigList: [],
			settingList: [],
			configLoading: false,
			configDialogVisible: false,
			configDialogTitle: '编辑车辆类型配置',
			chargingTypeOptions: [{ key: 3, value: '按分钟收费' }],
			configForm: {
				deviceTypeCode: '',
				deviceTypeName: '',
				bicycleType: null,
				chargingType: 3,
				stage1Minute: null,
				stage1Fee: null,
				stage2Minute: null,
				stage2Fee: null,
				stage3Minute: null,
				stage3Fee: null,
				sweepCodeStatus: false,
				sweepCodeTip: '',
				prechargeStatus: false,
				precharge: null,
				allowDispatch: false,
				dispatchingFee: null,
				operationTime: ['06:00', '23:00'],
				enableFenceReturn: false,
				enableBluetoothUnlock: false,
				enableOutAreaAlarm: false
			},
			configRules: {
				stage1Minute: [{ required: true, message: '请输入第1阶段分钟区间', trigger: 'blur' }],
				stage1Fee: [{ required: true, message: '请输入第1阶段收费金额', trigger: 'blur' }]
			}
		}
	},
	created() {
		this.distributorPageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.getdistributorList();
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.distributorPageInfoReq.queryDistributorId = distributorId || ''
			this.distributorPageInfoReq.page = 1
			this.getdistributorList()
		},
		async getdistributorList() {
			const { data: res } = await this.$http.post('/distributor/manager/list', this.distributorPageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.distributorList = res.data.list
			this.total = res.data.total
		},
		handleSizeChange(pageSize) {
			this.distributorPageInfoReq.limit = pageSize;
			this.getdistributorList();
		},
		handleCurrentChange(pageNum) {
			this.distributorPageInfoReq.page = pageNum;
			this.getdistributorList();
		},
		updateDistributorInit(id) {
			this.$http.get('/distributor/manager/getDistributorInfoById/' + id).then((res) => {
				if (res.data.code != 200) return this.$message.error(res.data.msg)
				this.distributorInfo = res.data.data;
				this.updateDistributorDialogVisible = true;
			});
		},
		updateDistributor() {
			this.$refs.distributorInfoUpdate.validate((valid) => {
				if (valid) {
					this.$http.post('/distributor/manager/updateDistributorById', this.distributorInfo).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.updateDistributorDialogVisible = false;
						this.getdistributorList();
						this.$message.success(res.data.msg);
					})
				}
			});
		},
		async distributorSettingInit(id) {
			this.currentDistributorId = id;
			this.configLoading = true;
			this.distributorSettingInitDialogVisible = true;
			
			try {
				const [deviceTypeRes, settingRes] = await Promise.all([
					this.$http.get('/device/typeConfig/list', { params: { distributorId: id, bicycleType: null } }),
					this.$http.get('/distributor/setting/getDistributorSettingList/' + id)
				]);
				
				if (deviceTypeRes.data.code === 200) {
					this.deviceTypeConfigList = deviceTypeRes.data.data || [];
				}
				if (settingRes.data.code === 200) {
					this.settingList = settingRes.data.data || [];
				}
			} catch (error) {
				console.error('加载配置失败:', error);
				this.$message.error('加载配置失败');
			} finally {
				this.configLoading = false;
			}
		},
		getSettingConfig(deviceTypeCode) {
			const setting = this.settingList.find(s => s.deviceTypeCode === deviceTypeCode);
			return setting || {};
		},
		editDeviceTypeConfig(row) {
			const existingSetting = this.settingList.find(s => s.deviceTypeCode === row.deviceTypeCode) || {};
			this.configForm = {
				deviceTypeCode: row.deviceTypeCode,
				deviceTypeName: row.deviceTypeName,
				bicycleType: row.bicycleType,
				chargingType: 3,
				stage1Minute: existingSetting.stage1Minute ?? null,
				stage1Fee: existingSetting.stage1Fee ?? null,
				stage2Minute: existingSetting.stage2Minute ?? null,
				stage2Fee: existingSetting.stage2Fee ?? null,
				stage3Minute: existingSetting.stage3Minute ?? null,
				stage3Fee: existingSetting.stage3Fee ?? null,
				sweepCodeStatus: existingSetting.sweepCodeStatus === 1,
				sweepCodeTip: existingSetting.sweepCodeTip || '',
				prechargeStatus: existingSetting.prechargeStatus === 1,
				precharge: existingSetting.precharge ?? null,
				allowDispatch: existingSetting.allowDispatch === 1,
				dispatchingFee: existingSetting.dispatchingFee ?? null,
				operationTime: existingSetting.operatingStartTime && existingSetting.operatingEndTime 
					? [existingSetting.operatingStartTime.substring(0, 5), existingSetting.operatingEndTime.substring(0, 5)] 
					: ['06:00', '23:00'],
				enableFenceReturn: existingSetting.enableFenceReturn === 1,
				enableBluetoothUnlock: existingSetting.enableBluetoothUnlock === 1,
				enableOutAreaAlarm: existingSetting.enableOutAreaAlarm === 1
			};
			this.configDialogTitle = '编辑车辆类型配置';
			this.configDialogVisible = true;
		},
		saveDeviceTypeConfig() {
			this.$refs.configFormRef.validate((valid) => {
				if (valid) {
					const saveData = {
						distributorId: this.currentDistributorId,
						deviceTypeCode: this.configForm.deviceTypeCode,
						bicycleType: this.configForm.bicycleType,
						chargingType: this.configForm.chargingType,
						stage1Minute: this.configForm.stage1Minute,
						stage1Fee: this.configForm.stage1Fee,
						stage2Minute: this.configForm.stage2Minute,
						stage2Fee: this.configForm.stage2Fee,
						stage3Minute: this.configForm.stage3Minute,
						stage3Fee: this.configForm.stage3Fee,
						sweepCodeStatus: this.configForm.sweepCodeStatus ? 1 : 0,
						sweepCodeTip: this.configForm.sweepCodeTip,
						prechargeStatus: this.configForm.prechargeStatus ? 1 : 0,
						precharge: this.configForm.precharge,
						allowDispatch: this.configForm.allowDispatch ? 1 : 0,
						dispatchingFee: this.configForm.dispatchingFee,
						operatingStartTime: this.configForm.operationTime && this.configForm.operationTime.length === 2 ? this.configForm.operationTime[0] + ':00' : '',
						operatingEndTime: this.configForm.operationTime && this.configForm.operationTime.length === 2 ? this.configForm.operationTime[1] + ':00' : '',
						enableFenceReturn: this.configForm.enableFenceReturn ? 1 : 0,
						enableBluetoothUnlock: this.configForm.enableBluetoothUnlock ? 1 : 0,
						enableOutAreaAlarm: this.configForm.enableOutAreaAlarm ? 1 : 0
					};
					
					this.$http.post('/distributor/setting/saveByDeviceType', saveData).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.$message.success('保存成功');
						this.configDialogVisible = false;
						this.distributorSettingInit(this.currentDistributorId);
					});
				}
			});
		}
	}
}
</script>

<style></style>
